import {TenantOverview} from 'src/app/services/tenant/tenant.service';

const MINUTE_MS = 60 * 1000;

/** Whole minutes left in the tenant's trial (rounded up), undefined unless a trial is running (KAB-2399). */
export function trialMinutesLeft(tenant: TenantOverview | undefined): number | undefined {
  const plan = tenant?.plan;
  const msLeft = plan?.isTrialPlan() ? plan.asTrialPlan().endAt.getTime() - Date.now() : NaN;
  return msLeft > 0 ? Math.ceil(msLeft / MINUTE_MS) : undefined;
}

/**
 * Neither active nor on a running trial: the workspace keeps only its blocking page, and the engine
 * answers 403 `tenant_suspended` to its data calls — callers skip them rather than fail (KAB-2399).
 */
export function isTenantSuspended(tenant: TenantOverview | undefined): boolean {
  return !!tenant?.plan && !tenant.plan.isActivePlan() && trialMinutesLeft(tenant) === undefined;
}
